import DashboardLayout from "./DashboardLayout";
import ProfileDetailsWithBidderForm from "./ProfileDetailsWithBidderForm";

export const ProfileSection = () => {
  return (
    <DashboardLayout>
      <p className="font-openSans font-normal text-mobile-subheading lg:text-web-h3 leading-6 lg:leading-[38px] text-brand-textGrey pt-3">
        General Information
      </p>
      <ProfileDetailsWithBidderForm />
    </DashboardLayout>
  );
};

export default ProfileSection;
